export const PATH_1 = 'assets/images/banners/full_screen.jpg';
export const PATH_2 = 'assets/images/banners_demo_2/full_screen.jpg';
export const PATH_3 = 'assets/images/banners_demo_2/full_screen_2.jpg';
